module.exports = __webpack_public_path__ + "img/Data Collaboration.357bebe9.svg";